module.exports = __webpack_public_path__ + "static/media/cozy9168.927d95fb.jpg";